export const adap_compra_mov = ({usuario, compra}) => {

    let obj = {
        tipo: compra.desde,
        idUsuario: usuario.id,
        codigoUsuario: usuario.codigo,
        fecha: compra.fecha,
        hashString: compra.hashString,
        hash: compra.hash,
        consecutivo: compra.consecutivo,
        nombre: usuario.nombre,
        valor: compra.valor,
        moneda: 'usd',
        departamento: 'Adminstracion',
        correo: usuario.correo,
        visible: 'Visible',
        detalle: compra.detalle,
        fechaRespuesta: compra.fechaRespuesta,
    }

    return obj


}